/* eslint-disable @typescript-eslint/no-unsafe-member-access */
/* eslint-disable @typescript-eslint/no-unsafe-assignment */
import request from '@hb/sharp-request';
import requestDefault from '@/shared/utils/request';
import store from '@/store';
import { isH5App, newGatewayUrl } from '@/constant';
import {
  SupportBankCard,
  UserThreeElements,
  SendSmsOrBindCardResult,
  BankInfoOfCardNo,
  SubmitBankCardResult,
  CardTypeEnum,
  BindCardFlowTypeEnum,
} from './types';

// 获取支持该渠道的银行卡
export const getSupportBanks = (
  commodityId: string,
  capitalCode?: string,
  type: CardTypeEnum = CardTypeEnum.DebitCard,
): Promise<SupportBankCard[]> => request
  .postGate(
    'f.common.dict.list',
    {
      type,
      commodityId,
      catalog: 'bankInfo',
      capitalCode,
    },
    {
      showLoading: undefined,
      baseURL: newGatewayUrl,
    },
  )
  .then((data) => (data || []) as SupportBankCard[]);

// 获取用户三要素
export const getUserInformation = (): Promise<UserThreeElements> => request.postGate('f.user.three.elements', {}, { baseURL: newGatewayUrl });

// 发送短信验证码 或者 绑定银行卡
export const sendSmsOrBindCard = (params: {
  cardNo: string;
  cardType: CardTypeEnum;
  commodityId: string;
  reservePhone: string;
  /** 如果没传值默认走BindCardFlowTypeEnum.REPAY场景 */
  bindCardFlowType?: BindCardFlowTypeEnum;
  capitalCode?: string;
  /** 订单 id */
  loanOrderId?: string;
}): Promise<SendSmsOrBindCardResult> => requestDefault.postGate('f.card.bind.apply', {
  platform: isH5App ? 'h5' : '',
  deviceInfo: store.getters['base/devicesJSON'],
  ...params,
});

// 根据银行卡号查询归属的银行名称以及卡类型
export const getBankInfoByCardNo = (
  cardNo: string,
  /** 是否需要校验资方支持该银行卡不，默认false */
  checkCapital?: boolean,
  /** 资方code，多资方以_隔开 */
  capitalCode?: string,
  /** 渠道id */
  commodityId?: string,
): Promise<BankInfoOfCardNo> => requestDefault.postGate(
  'f.card.cardNo.getBankInfo',
  {
    cardNo, checkCapital, capitalCode, commodityId,
  },
  {
    showLoading: undefined,
    showErrMsg: undefined,
  },
);

// 根据userBankId获取银行卡号
export const getCardNoByUserBankId = (
  userBankId: string,
): Promise<{ cardNo: string }> => requestDefault.postGate('f.card.userBankId.getBankInfo', { userBankId });

// 提交绑卡验证申请
export const submitCardBind = (params: {
  smsCode: string;
  // 绑卡申请编号
  cardApplyId: string;
  // 合作方绑卡申请编号
  thirdApplyId: string;
  /** 不传默认BindCardFlowTypeEnum.REPAY */
  bindCardFlowType?: BindCardFlowTypeEnum;
  capitalCode?: string;
  /** 借款订单 id */
  loanOrderId?: string;
}): Promise<SubmitBankCardResult> => requestDefault.postGate('f.card.bind.auth',
  {
    platform: isH5App ? 'h5' : '', // TODO: 接口未做特殊处理 先不改动
    deviceInfo: store.getters['base/devicesJSON'],
    ...params,
  },
  {
    loadingMessage: '绑卡验证中，请勿退出',
  });
